import React from 'react';

import { MdmDeviceDto, useGetDeviceQuery, useUpdateDeviceMutation } from 'gql/generated/types';
import { ProgressSpinner } from 'primereact/progressspinner';
import { useParams } from 'react-router-dom';
import { T } from 'services/lang/LanguageService';
import DeviceForm from '../components/DeviceForm';
import { apolloErrorToaster, successToaster } from '../utils/utils';
import ErrorPage from './ErrorPage';

const EditDeviceForm = () => {
  const { deviceId } = useParams();
  const { data, error, loading } = useGetDeviceQuery({ variables: { id: deviceId! } });
  const [updateDeviceMutation, { loading: updateLoading }] = useUpdateDeviceMutation({
    onCompleted: () => successToaster(T("alert.device-updated-successfully")),
    onError: apolloErrorToaster,
  });

  if (error) {
    return <ErrorPage msg={error.message} />;
  }

  if (loading) return <ProgressSpinner className='mt-3 w-full' />

  const handleUpdate = (device: Partial<MdmDeviceDto>) => {
    const { project, objectRelation, boundDatasets, status, createdAt, modifiedAt, ...restDevice } = device
    updateDeviceMutation({
      variables: {
        device: {
          ...restDevice,
          roleIdentifier: objectRelation?.roleIdentifier,
          roleInObject: objectRelation?.roleInObject,
        },
        objectId: objectRelation?.mdmObject?.id!,
      },
    });
  };

  return (
    <DeviceForm
      device={data?.mdmDeviceById as MdmDeviceDto}
      onSubmit={handleUpdate}
      loading={updateLoading}
    />
  );
}

export default EditDeviceForm